__turbopack_context__.v({
  "CompaniesBanner": "CompaniesSearchBanner-module-scss-module__Sfn0VW__CompaniesBanner",
});
